Application.Forms.Validators = {
    map: {
        'class-only': 'ClassOnlyValidator',
        'error-message': 'ErrorMessageValidator'
    },
    parent: {
        addError: window.Nette.addError,
        validateControl: window.Nette.validateControl,
        validateForm: window.Nette.validateForm
    },
    ready: function () {
        
        var self = this;

        // init default validator
        this.defaultValidator = this.createDefaultValidator();

        // override
        window.Nette.addError = function(el, message){
            var validator = self.getValidator($(el).parents('form'));
            // call validator error handler
            validator.onError.apply(this, arguments);
        };
        window.Nette.validateControl = function(el, rules, onlyCheck){
            var validator = self.getValidator($(el).parents('form'));
            if (!onlyCheck){
                // call validator success handler
                validator.onSuccess.call(this, el);
            }
            return self.parent.validateControl.apply(this, arguments);
        };

    },
    createDefaultValidator: function(){
        
        return {
            onError: this.parent.addError,
            onSuccess: function(){  }
        };
        
    },
    getValidator: function($form){
        
        var id = $form.data('validator');
        
        return this.map[id] ? this[this.map[id]] : this.defaultValidator;
        
    }
}